import { render, staticRenderFns } from "./SkeletonBlock.vue?vue&type=template&id=15046e7d&scoped=true&"
import script from "./SkeletonBlock.vue?vue&type=script&lang=js&"
export * from "./SkeletonBlock.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonBlock.vue?vue&type=style&index=0&id=15046e7d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15046e7d",
  null
  
)

export default component.exports